import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NO_RECORDS_IMAGE_SRC } from '../../constants/commonConstants';

@Component({
  selector: 'no-records-placeholder',
  templateUrl: './no-records-placeholder.component.html',
  styleUrls: ['./no-records-placeholder.component.scss'],
  standalone: false,
})
export class NoRecordsPlaceholderComponent {
  @Input() showNoRecordsHeader: boolean = false;
  @Input() noRecordsHeader: string;
  @Input() noRecordsSubheaderText1: string = 'common.noRecords.subheaderText1';
  @Input() noRecordsSubheaderText2: string = 'common.noRecords.subheaderText2';
  @Output() clickHereEvent: EventEmitter<Event> = new EventEmitter<Event>();
  @Input() noRecordsSubheaderText3: string = 'common.noRecords.subheaderText3';
  @Input() noRecordsImageSrc: NO_RECORDS_IMAGE_SRC = NO_RECORDS_IMAGE_SRC.DEFAULT;
  @Input() isActiveFilter: boolean = false;

  noRecordsHeaderValue: string;

  NO_RECORDS_IMAGE_SRC = NO_RECORDS_IMAGE_SRC;

  public clickHereHandler(event: any) {
    event.preventDefault();
    this.clickHereEvent.emit();
  }
}
